<template>
  <div>
    <div v-if="error" class="alert alert-primary bg-primary text-white border-0 show">
      {{$t(error)}}
    </div>

    <b-form novalidate @submit.prevent="submit">
      <div class="row">
        <div class="col-lg-6">
          <validated-form-input tabindex="0" name="titleEst" label="Nimetus eesti keeles" placeholder="Nimetus eesti keeles" v-model="service.titleEst"
                                validate="required" :validator="$validator"/>

          <validated-form-select name="category" :options="categories" label="Kategooria" placeholder="- Vali kategooria -"
                                 v-model="service.category" validate="required"
                                 :validator="$validator"/>
        </div>

        <div class="col-lg-6">
          <validated-form-input name="titleEng" label="Nimetus inglise keeles" placeholder="Nimetus inglise keeles" v-model="service.titleEng"
                                validate="required" :validator="$validator"/>

          <validated-form-input  tabindex="1" name="excellentArticleCode" label="Booksi artikkel" placeholder="Booksi artikkel" v-model="service.excellentArticleCode"
                                validate="required" :validator="$validator"/>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <submit-button class="float-right" variant="primary" :disabled="submitting">Salvesta</submit-button>
        </div>
      </div>

    </b-form>

  </div>
</template>

<script>
  import ValidatedFormInput from '@/components/ValidatedFormInput'
  import ValidatedFormSelect from '@/components/ValidatedFormSelect'

  export default {
    components: {ValidatedFormInput, ValidatedFormSelect},
    data() {
      return {
        service: {
          titleEst: null,
          titleEng: null,
          excellentArticleCode: null,
          category: null
        },
        categories: [],
        submitting: false,
        error: null
      }
    },
    created() {
      this.$gateway.get('/provided-service-groups').then(r => {
        this.categories = r.data.map(entry => ({text: entry, value: entry}))
      })
    },
    methods: {
      submit() {
        if (this.submitting) return;
        this.submitting = true

        this.$validator.validateAll().then(valid => {
          if (!valid) {
            this.submitting = false
            return
          }
          this.$gateway.post('/admin/services', this.service)
            .then(r => {
              this.$notifications.info(`Teenus on lisatud`)
              this.submitting = false
              this.$emit('done')
            })
            .catch(r => {
              this.error = r.response.data.key
              this.submitting = false
            })
        })
      }
    }
  }
</script>
